angular.module('picmonicng').component('homeFooter', {
  templateUrl: '/templates/app/components/home-footer/home-footer.html',
  bindings: {},
  controller: [
    'UserService',
    function (UserService) {
      var $ctrl = this;
      $ctrl.UserService = UserService;
    },
  ],
});
